import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { PARAM_LABEL_INTERVENTION } from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { Funder } from 'src/app/shared/models/funder';
import { MissionType } from 'src/app/shared/models/mission/mission-type';
import { Specialite } from 'src/app/shared/models/specialite';

@Component({
	selector: 'app-edit-mission-type-modal',
	templateUrl: './edit-mission-type-modal.component.html',
	styleUrls: ['./edit-mission-type-modal.component.scss']
})
export class EditMissionTypeModalComponent implements OnInit {
	NAME_PATTERN = '^[^0-9]+$';

	formEdit = new FormGroup({
		type: new FormControl('', [
			Validators.required,
			Validators.pattern(this.NAME_PATTERN),
			Validators.maxLength(32)
		]),
		isAutoAssignment: new FormControl(true),
		isForExternalService: new FormControl(false),
		isEmployeeExternal: new FormControl(false),
		numberOfEmployee: new FormControl(),
		funder: new FormControl('')
	});

	missionType: MissionType;

	confirmDeleteModalRef: BsModalRef;

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked = false;

	labelIntervention: string;

	funders: Funder[];
	selectedFunder: Funder;

	isFunderActive: boolean;

	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	ngOnInit(): void {
		if (this.missionType) {
			this.formEdit.setValue({
				type: this.missionType.type,
				isForExternalService: this.missionType.forExternalService
					? this.missionType.forExternalService
					: false,
				isAutoAssignment: this.missionType.autoAssignment
					? this.missionType.autoAssignment
					: false,
				isEmployeeExternal: this.missionType.employeeExternal
					? this.missionType.employeeExternal
					: false,
				numberOfEmployee: this.missionType.numberOfEmployee,
				funder: this.missionType.funder ? this.missionType.funder.name : null
			});
		}

		this.labelIntervention = this.facade.dataStorageService.getLabel(
			PARAM_LABEL_INTERVENTION
		);

		this.isFunderActive = this.facade.dataStorageService.isFunderActive();
		if (this.isFunderActive) {
			this.getFunders();
		}
	}

	getFunders() {
		this.facade.funderService.getAllFunders().subscribe({
			next: (funders) => {
				this.funders = funders;
			},
			error: (err) => {
				this.isValidateButtonClicked = false;
				this.facade.toastService.createHttpErrorToast(
					err.error.response ? err.error.response : '',
					err.status
				);
				this.logger.error(err);
			}
		});
	}

	onExternalMissionTypeChange() {
		if (this.formEdit.get('isForExternalService').value) {
			this.formEdit.controls['isAutoAssignment'].setValue(false);
		} else {
			this.formEdit.controls['isAutoAssignment'].setValue(true);
		}
	}

	onSubmit() {
		this.isValidateButtonClicked = true;
		this.missionType.type = this.formEdit.get('type').value;
		this.missionType.employeeExternal =
			this.formEdit.get('isEmployeeExternal').value;
		this.missionType.forExternalService = this.formEdit.get(
			'isForExternalService'
		).value;
		this.missionType.autoAssignment =
			this.formEdit.get('isAutoAssignment').value;
		this.missionType.funder = this.selectedFunder;
		this.missionType.numberOfEmployee = this.formEdit.get('numberOfEmployee').value;

		this.facade.missionTypeService
			.updateMissionType(this.missionType)
			.subscribe({
				next: (succ) => {
					// this.isValidateButtonClicked=false;
					this.bsModalRef.hide();
				},
				error: (err) => {
					this.isValidateButtonClicked = false;
				}
			});
	}

	openModal(confirmDeleteTemplate: TemplateRef<any>): void {
		this.confirmDeleteModalRef = this.modalService.show(confirmDeleteTemplate);
	}

	funderKeyUp(e: any) {
		if (this.selectedFunder && this.selectedFunder.name !== e.value) {
			this.selectedFunder = null;
		}
	}

	typeaheadFunderOnSelect(event: TypeaheadMatch): void {
		this.selectedFunder = event.item as Funder;
		this.formEdit.patchValue({ funder: event.item.name }, { onlySelf: true });
	}

	delete() {
		this.facade.missionTypeService
			.deleteMissionType(this.missionType.id)
			.subscribe({
				next: (succ) => {
					this.modalService.hide();
					this.bsModalRef.hide();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.response ? err.error.response : '',
						err.status
					);
				}
			});
	}

	get type() {
		return this.formEdit.get('type');
	}
	get isEmployeeExternal() {
		return this.formEdit.get('isEmployeeExternal');
	}
	get isAutoAssignment() {
		return this.formEdit.get('isAutoAssignment');
	}
	get isForExternalService() {
		return this.formEdit.get('isForExternalService');
	}
	get funder() {
		return this.formEdit.get('funder');
	}
	get numberOfEmployee() {
		return this.formEdit.get('numberOfEmployee');
	}
}
